import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { BACKEND } from "../config/configEnvs";
import { toast } from "react-toastify";
import { FiShare2 } from "react-icons/fi";
import { useSelector } from "react-redux";
import { Button, Pagination } from "@mui/material";
import { FaFacebook, FaFilter, FaInfoCircle, FaInstagram, FaLink, FaLinkedin, FaSpinner, FaTiktok, FaTimes, FaYoutube } from "react-icons/fa";
import SearchIcon from '@mui/icons-material/Search';
import FilterRedesClientesColsDialog from "../components/dialogs/FilterRedesClientesColsDialog";
import Modal from "../components/ui/Modal";
import useFetchRequestGet from "../hooks/useFetch";
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { BiWorld } from "react-icons/bi";
import Tooltip from "../components/ui/ToolTip";

const RedesClientes = () => {

  const user = useSelector((state) => state.auth.user)
  // const [activeServiciosList, setActiveServiciosList] = useState([]); // Columnas activas

  const [loadingStatus, setLoadingStatus] = useState(false) // Estado de carga

  const [serviceFilters, setServiceFilters] = useState([]) // Filtros de servicios seleccionados

  const [debouncedValue, setDebouncedValue] = useState(serviceFilters); // debounce

  const [clients, setClients] = useState([]) // Clientes
  const [services, setServices] = useState([]) // Servicios en total

  const [page, setPage] = useState(1); // Pagina actual
  const [limit, setLimit] = useState(10) // Limite 
  const [totalDocs, setTotalDocs] = useState(1) // Total de documentos
  const [totalPages, setTotalPages] = useState(1) // Total de paginas

  const [startDate, setStartDate] = useState("") // Fecha inicio
  const [endDate, setEndDate] = useState("") // Fecha fin

  const [agencyWeb, setAgencyWeb] = useState(false) // Activo agencia

  const [brandName, setBrandName] = useState("") // Buscador por nombre de marca


  const [linksModalLoading, setLinksModalLoading] = useState(false)

  const [openLinksModal, setOpenLinksModal] = useState(false) // Estado de modal de Links del servicio
  const [openFilterModal, setOpenFilterModal] = useState(false); // Estado de modal filtros de columnas
  const [openClientMediaModal, setOpenClientMediaModal] = useState(false)


  const { dataList: filtradoList } = useFetchRequestGet({
    page: 1,
    endpoint: "servicioFiltrado",
  });

  // Seleccion de cliente
  
  const [linkList, setLinkList] = useState([])

  const linksWithoutNets = linkList.filter((link) => // Filtramos los links que no contengan redes
    link.titulo !== "Link web oficial" && 
    link.titulo !== "Link demo" && 
    link.titulo !== "Link backup"
  );

  const [selectedClient, setSelectedClient] = useState({})

  const handleSave = async () => { // Guardamos los links
    const validateLink = (link) => !link || link.startsWith("https");

    const invalidLinks = [ // Verificamos que tengan https antes de guardarlos
      { name: "Facebook", value: selectedClient.linkFacebook, },
      { name: "Instagram", value: selectedClient.linkInstagram },
      { name: "LinkedIn", value: selectedClient.linkLinkedin },
      { name: "YouTube", value: selectedClient.linkYoutube },
      { name: "TikTok", value: selectedClient.linkTiktok },
      { name: "Web", value: selectedClient.linkWeb },
    ].filter((link) => !validateLink(link.value));
  
    if (invalidLinks.length > 0) {
      toast.error(`Los siguientes enlaces deben comenzar con "https": ${invalidLinks.map((l) => l.name).join(", ")}`);
      return;
    }

    try {
      const response = await axios.put(`${BACKEND}/api/clientesUser/${selectedClient.id}`, {
        linkFacebook: selectedClient.linkFacebook || "",
        linkTiktok: selectedClient.linkTiktok || "",
        linkLinkedin: selectedClient.linkLinkedin || "",
        linkInstagram: selectedClient.linkInstagram || "",
        linkYoutube: selectedClient.linkYoutube || "",
        linkWeb: selectedClient.linkWeb || ""
      })

      setClients((prevClients) => 
        prevClients.map((client) =>
          client.id === selectedClient.id ? { ...client, ...response.data.doc } : client
        )
      )


      
      toast.success("Links actualizados con éxito")
    } catch (error) {
      console.log(error)
      toast.error("Error al actualizar los links")
    }
  }


  /// Debouncer

  const useDebounce = (value) => {
    const [debouncedValue, setDebouncedValue] = useState(value);
  
    useEffect(() => {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, 1000);
  
      return () => {
        clearTimeout(handler);
      };
    }, [value]);
  
    return debouncedValue;
  };

  const debouncedServiceFilters = useDebounce(serviceFilters); // 2 segundos de retraso


  useEffect(() => {
    if (debouncedServiceFilters.length > 0) {
      getClients();
    }
  }, [debouncedServiceFilters]);

  // Fin debouncer



  // Links servicios clientes

  const [url, setUrl] = useState("")
  const [titulo, setTitulo] = useState()

  const [clientSelected, setClientSelected] = useState("")
  const [serviceSelected, setServiceSelected] = useState("")

  const fetchLinkServiciosClientes = async (clientId, serviceId) => { // Pedir los links del cliente
    try {
      setLinksModalLoading(true)

      const response = await axios.get(`${BACKEND}/api/LinksServiciosClientes?limit=0&where[cliente][equals]=${clientId}&where[servicio][equals]=${serviceId}`)
      setLinkList(response.data.docs)

    } catch (e) {
      console.log(e)
    } finally {
      setLinksModalLoading(false)
    }
  };

  const createLink = async (clientId, serviceId) => { // Se crea el link
    try {
      if (!clientId || !serviceId) {
        toast.warning("No hay un cliente o servicio seleccionado")
        return
      }

      await axios.post(`${BACKEND}/api/LinksServiciosClientes`, {
        url,
        titulo,
        cliente: clientId,
        servicio: serviceId
      });
      toast.success("Link creado exitosamente")
    } catch (error) {
      console.log(error)
      toast.error("Error al crear el link")
    }
  };

  const deleteLink = async (id) => { // Eliminar un link
    try {
      await axios.delete(`${BACKEND}/api/LinksServiciosClientes/${id} `);
      fetchLinkServiciosClientes(clientSelected, serviceSelected);
      toast.success("Link eliminado exitosamente")
    } catch (error) {
      console.log(error)
      toast.error("Error al eliminar")
    }
  };

  // Fin servicios clientes


  // Rubro y nicho

  const [rubros, setRubros] = useState([])
  const [nichos, setNichos] = useState([])
  
  const [rubroSelected, setRubroSelected] = useState("")
  const [nichoSelected, setNichoSelected] = useState("")

  const getRubros = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/clientesRubros?limit=0`)
      setRubros(response.data.docs)
    } catch (e) {
      console.log(e)
    }
  }

  const getNichos = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/clientesNichos?where[rubro][equals]=${rubroSelected}`)
      setNichos(response.data.docs)
    } catch (e) {
      console.log(e)
    }
  }

  // Fin rubro y nicho
  
  const debounceUpdate = useRef(null); // Referencia para mantener el debouncer

  const handleUpdateText = (field, newValue, clientId) => { // Cambiar el texto con lógica de debouncer

    setClients((prevData) =>
      prevData.map((client) =>
        client.id === clientId
          ? {
              ...client,
              [field]: newValue,
            }
          : client
      )
    );

    if (debounceUpdate.current) {
      clearTimeout(debounceUpdate.current);
    }
    debounceUpdate.current = setTimeout(async () => {

      try {

        await axios.put(`${BACKEND}/api/clientesUser/${clientId}`, {
          [field]: newValue,
        });

        toast.success("Dato actualizado con éxito");
      } catch (error) {
        console.error(error);
        toast.error("Error al actualizar la fecha");
      }
    }, 1000); // Esperar 2 secs luego de que el usuario deja de ecsribir
  };
  
  const handleFilterByQuickFilter = (filter) => {
    setServiceFilters(filter.servicios.map((e) => e.item.id))    
  }

  const getClients = async () => {
    try {
      setLoadingStatus(true)

      const body = {}

      let url = `${BACKEND}/api/userProcessesInterface/getClientsWithServices?page=${page}&limit=${limit}`

      if (brandName) {
        url += `&brandName=${brandName}`
      }

      if (serviceFilters) {
        body.serviceFilters = serviceFilters
      }

      if (agencyWeb) {
        url += `&activoAgencia=${agencyWeb}`
      }

      if (startDate) {
        url += `&startDate=${new Date(startDate).toISOString()}`
      }

      if (endDate) {
        url += `&endDate=${new Date(endDate).toISOString()}`
      }

      if (nichoSelected) {
        url += `&nicho=${nichoSelected}`
      }

      const response = await axios.post(url, body)

      setClients(response.data.clients)
      setTotalPages(response.data.totalPages)
      setTotalDocs(response.data.totalDocs)

    } catch (e) {
      toast.error("Error: " + e)
    } finally {
      setLoadingStatus(false)
    }
  }

  const getServices = async () => {
    try {
      const response = await axios.get(
        `${BACKEND}/api/servicios?limit=0&sort=createdAt&where[monstrarRedesClientes][equals]=true`
      );
      setServices(response.data.docs);

      setServiceFilters(
        JSON.parse(localStorage.getItem("activeTableColsRedesClientes"))
      );
      const activeColsRedesC = await (JSON.parse(
        localStorage.getItem("activeTableColsRedesClientes")
      )
        ? JSON.parse(localStorage.getItem("activeTableColsRedesClientes"))
        : response.data.docs.map((doc) => doc.id));

      if (activeColsRedesC && response?.data?.docs) {
        setServiceFilters(
          activeColsRedesC.length > 0 ? activeColsRedesC : response.data.docs.map((doc) => doc.id)
        );
        localStorage.setItem(
          "activeTableColsRedesClientes",
          JSON.stringify(activeColsRedesC)
        );
      }
    } catch (error) {
      toast.error(error)
    }
  };

  const handleSearchClients = () => { // Buscamos clientes y colocamos página 1
    setPage(1)
    getClients()
  }

  const handlePageChange = (event, value) => { // Cambiar la página
    setPage(value)
  }

  const handlerChangeServiceFilter = (service, checked) => { // Manejador para el selector de servicios
    if (checked) {
      setServiceFilters((prev) => [...prev, service.id])
    } else {
      setServiceFilters((prev) => 
      prev.filter((serviceId) => serviceId !== service.id))
    }
  }

  const handleResetSearch = () => { // Resetea la búsqueda
    setBrandName(""); // Cambiar el estado
  };

  const handleUpdateSelect = async (field, newValue, clientId) => { // Cambiar un selector, sin debouncer
    
    setClients((prevData) =>
      prevData.map((client) =>
        client.id === clientId
          ? {
              ...client,
              [field]: newValue,
            }
          : client
      )
    );

    try {
      await axios.put(`${BACKEND}/api/clientesUser/${clientId}`, {
        [field]: newValue,
      });
      toast.success("Dato actualizado con éxito");
    } catch (error) {
      console.error(error);
      toast.error("Error al actualizar la fecha");
    }
  }

  useEffect(() => {
    getServices()
    getClients()
    getRubros()
  }, []);
  
  useEffect(() => {
    if (rubroSelected === "") {
      setNichoSelected("")
    } else {
      getNichos()
    }
  }, [rubroSelected])

  useEffect(() => { // Solo se ejecuta cuando se vacea la barra de búsqueda
    if (brandName === "") {
      getClients(); // Solo se ejecuta cuando se reinicia la búsqueda
      setPage(1); // Reiniciar la paginación si es necesario
    }
  }, [brandName]);

  useEffect(() => {
    getClients();
  }, [page, limit, agencyWeb, startDate, endDate, nichoSelected]);

  useEffect(() => {
    if (serviceFilters.length > 0) {
      localStorage.setItem(
        "activeTableColsRedesClientes",
        JSON.stringify(serviceFilters)
      );
    }
  }, [serviceFilters]);

  return (
    <div className="flex flex-col h-screen w-full">

      <Modal // Modal de filtros
        activeModal={openFilterModal}
        onClose={() => setOpenFilterModal(false)}
        title="Servicios a mostrar"
        centered
      >
        <div 
          className="flex flex-col gap-4 text-xs"
        >
          <div className="mb-4 flex justify-start gap-2 items-center flex-wrap">
            {filtradoList.map((e) => (
              <button
              onClick={() => handleFilterByQuickFilter(e)}
                className=" bg-orange-600 bg-opacity-10 hover:bg-opacity-20 transition duration-300 p-2 rounded-md text-orange-600 font-semibold"
                type="buttton"
                key={e.id}
              >
                {e.name}
              </button>
            ))}
          </div>
          <div className="workers">
            <div className="grid grid-cols-3 gap-2">
              {services.map((service) => (
                <div key={service.id} className="bg-gray-100 justify-between px-4 py-1 rounded-full flex flex-row gap-2 items-center">
                  <div className="flex flex-col max-w-[80%]">
                    <span className="text-xs truncate font-bold">{service.name}</span>
                  </div>
                  <input
                    type="checkbox"
                    className="rounded-md border-gray-400 hover:cursor-pointer"
                    checked={serviceFilters.includes(service.id)}
                    onChange={(e) =>
                      handlerChangeServiceFilter(service, e.target.checked)
                    }
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </Modal>

      <Modal // Modal de links
        activeModal={openLinksModal}
        onClose={() => {
          setOpenLinksModal(false)
          setLinkList([])
          setClientSelected("")
          setServiceSelected("")
          setUrl("")
          setTitulo("")
        }}
        title="Links del servicio"
        centered
      >
        <div className="flex-grow w-full">
          {linksModalLoading ? (
            <div className="flex w-full h-full text-gray-700 items-center justify-center">
              <div className="flex w-full h-full text-xs gap-2 items-center justify-center">
                <span>Cargando, por favor espera...</span>
                <FaSpinner className="animate-spin text-gray-500" />
              </div>
            </div>
            ) : (
              <>
                <div className="flex flex-row w-full gap-4">
        
                  {/* Nombre del link */}
                  <div className="w-[45%]">
                    <label
                      className="block mb-2 text-xs font-medium text-gray-900 "
                    >
                      Nombre del Link
                    </label>
                    <input
                      type="text"
                      value={titulo}
                      placeholder="Ingresa el nombre del link..."
                      onChange={(e) => setTitulo(e.target.value)}
                      className="block text-xs w-full py-2 text-gray-900 border border-gray-300 rounded-lg bg-gray-50 sm:text-md focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
        
                  {/* Link */}
                  <div className="w-[45%]">
                    <label
                      htmlFor="large-input"
                      className="block mb-2 text-xs font-medium text-gray-900 "
                    >
                      Link
                    </label>
                    <input
                      type="text"
                      value={url}
                      placeholder="Ingresa el link..."
                      onChange={(e) => setUrl(e.target.value)}
                      id="large-input"
                      className="block text-xs w-full py-2 text-gray-900 border border-gray-300 rounded-lg bg-gray-50 sm:text-md focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
        
                  {/* Guardar el link */}
                  <div className="flex items-end justify-center w-[10%]">
        
                    <Button 
                      variant="contained"
                      sx={{
                        paddingInline: "30px",
                        paddingBlock: "6px",
                        width: "100%",
                        fontSize: "12px",
                        fontWeight: "light",
                        fontFamily: "poppins",
                        backgroundColor: "#ff6400",
                        transform: "all",
                        animationDuration: "1000",
                        textTransform: "none",
                        borderRadius: "8px",
                        '&:hover': {
                          backgroundColor: "#bb4a03",
                        }
                      }}
                      onClick={() => {
                        createLink(clientSelected, serviceSelected)
                        setOpenLinksModal(false)
                        setTitulo("")
                        setUrl("")
                      }}
                    >
                      Guardar
                    </Button>
                  </div>
        
                </div>
        
                {/* Divisor */}
                <div  className="py-6">
                  <hr className=" "/>
                </div>
        
                {/* Links creados */}
          
                <div className="flex flex-col gap-4">
          
                  <div class="text-xs text-gray-700 font-bold bg-gray-50">
                    Links creados
                  </div>
        
                  <div className="flex flex-col gap-2 items-center justify-center">
                    {linksWithoutNets && linksWithoutNets.length > 0 ? (
                      <>
                        <div className="flex flex-row w-full gap-4 text-xs text-gray-700">
                          <span className="w-[45%] px-4">Nombre</span>
                          <span className="w-[45%] px-4">Link</span>
                          <span className="w-[10%]">Eliminar</span>
                        </div>
        
                        {linksWithoutNets.map((e) => (
                          <div className="flex flex-row w-full py-2 gap-4">
        
                            <div className="w-[45%] flex items-center justify-start px-4 border border-gray-300 rounded-lg py-1 bg-gray-50">
                              <span
                                className="text-xs break-all"
                              >
                                {e.titulo}
                              </span>
                            </div>
        
                            <div className="w-[45%] flex items-center justify-start px-4 border border-gray-300 rounded-lg py-1 bg-gray-50">
                              <a 
                                rel={"noreferrer"} 
                                href={e?.url} 
                                target="_blank"
                                className="text-xs break-all"              
                              > 
                                {e.url}
                              </a>
                            </div>
                  
                            <div className="w-[10%] flex items-center justify-center">
                              <IconButton 
                                aria-label="delete" 
                                size="small" 
                                onClick={() => deleteLink(e.id)}
                              >
                                <DeleteIcon 
                                  fontSize="inherit" 
                                  color="error"
                                />
                              </IconButton>
                            </div>
        
                          </div>
                        ))}
                      </>
                    ) : (
                      <div class="text-center w-full py-8 text-xs text-gray-700 bg-gray-50 border border-gray-300 rounded-lg">
                        <span>No hay links creados</span>
                      </div>
                    )}
        
                  </div>
          
                </div>
              </>
            )
          }
        </div>
      </Modal>

      <Modal // Modal de redes sociales
        activeModal={openClientMediaModal}
        onClose={() => {
          setOpenClientMediaModal(false)
          setSelectedClient({})
        }}
        title={`Redes Sociales ${selectedClient.nombreComercial}`}
        centered
      >
        <div
          className="max-h-[75vh] overflow-y-auto"
        >

          <div className="mb-4 mt-4">
            <label className="text-xs block text-gray-700 mb-2" htmlFor="linkFacebook">
                Link facebook
            </label>
            <div className="flex">
              <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                <FaFacebook />
              </span>
              <input
                type="text"
                id="linkFacebook"
                name="linkFacebook"
                placeholder="facebook.com"
                value={selectedClient.linkFacebook}
                onChange={(e) => setSelectedClient((prev) => ({...prev, linkFacebook: e.target.value}))}
                className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
              />
            </div>
          </div>

          <div className="mb-4 mt-4">
            <label className="text-xs block text-gray-700 mb-2" htmlFor="linkTiktok">
                Link tiktok
            </label>
            <div className="flex">
              <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                <FaTiktok />
              </span>
              <input
                type="text"
                id="linkTiktok"
                name="linkTiktok"
                placeholder="tiktok.com"
                value={selectedClient.linkTiktok}
                onChange={(e) => setSelectedClient((prev) => ({...prev, linkTiktok: e.target.value}))}
                className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
              />
            </div>
          </div>

          <div className="mb-4 mt-4">
            <label className="text-xs block text-gray-700 mb-2" htmlFor="linkLinkedin">
                Link linkedin
            </label>
            <div className="flex">
              <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                <FaLinkedin />
              </span>
              <input
                type="text"
                id="linkLinkedin"
                name="linkLinkedin"
                placeholder="linkedin.com"
                value={selectedClient.linkLinkedin}
                onChange={(e) => setSelectedClient((prev) => ({...prev, linkLinkedin: e.target.value}))}
                className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
              />
            </div>
          </div>

          <div className="mb-4 mt-4">
            <label className="text-xs block text-gray-700 mb-2" htmlFor="linkInstagram">
                Link instagram
            </label>
            <div className="flex">
              <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                <FaInstagram />
              </span>
              <input
                type="text"
                id="linkInstagram"
                name="linkInstagram"
                placeholder="instagram.com"
                value={selectedClient.linkInstagram}
                onChange={(e) => setSelectedClient((prev) => ({...prev, linkInstagram: e.target.value}))}
                className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
              />
            </div>
          </div>

          <div className="mb-4 mt-4">
            <label className="text-xs block text-gray-700 mb-2" htmlFor="linkYoutube">
                Link Youtube
            </label>
            <div className="flex">
              <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                <FaYoutube />
              </span>
              <input
                type="text"
                id="linkYoutube"
                name="linkYoutube"
                placeholder="youtube.com"
                value={selectedClient.linkYoutube}
                onChange={(e) => setSelectedClient((prev) => ({...prev, linkYoutube: e.target.value}))}
                className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
              />
            </div>
          </div>

          <div className="mb-4 mt-4">
            <label className="text-xs block text-gray-700 mb-2" htmlFor="linkWeb">
                Link Web
            </label>
            <div className="flex">
              <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                <BiWorld />
              </span>
              <input
                type="text"
                id="linkWeb"
                name="linkWeb"
                placeholder="marca.com"
                value={selectedClient.linkWeb}
                onChange={(e) => setSelectedClient((prev) => ({...prev, linkWeb: e.target.value}))}
                className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
              />
            </div>
          </div>

          <Button 
            variant="contained"
            sx={{
              fontWeight: "bold",
              fontFamily: "poppins",
              paddingBlock: "4px",
              backgroundColor: "#ff6400",
              transform: "all",
              marginTop: "20px",
              animationDuration: "1000",
              textTransform: "none",
              borderRadius: "8px",
              width: "100%",
              '&:hover': {
                backgroundColor: "#bb4a03",
              }
            }}
            onClick={() => handleSave()}
          >
            Guardar
          </Button>
        
        </div>
      </Modal>

      {/* NavBar */}
      <div className="flex flex-row px-4 py-2 bg-gray-100">
        <div className="flex flex-row w-full items-center gap-4 justify-between">

          <div className="flex items-center gap-4 py-4">
            <FiShare2 className="text-zinc-700 text-2xl" />
            <h2 className="text-2xl font-bold text-zinc-700">Redes clientes</h2>
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">
           
           <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
             <span>Límite:</span>
             <select
               value={limit}
               onChange={(e) => setLimit(e.target.value)}
               className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
             >
               <option value="10">10</option>
               <option value="20">20</option>
               <option value="30">30</option>
               <option value="40">40</option>
               <option value="50">50</option>
             </select>
           </div>

           <div className="relative w-full">
             <input
               type="text"
               placeholder="Buscar marca"
               className="w-[16rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
               value={brandName}
               onChange={(e) => setBrandName(e.target.value)}
             />
             {brandName && (
               <FaTimes
                 onClick={() => handleResetSearch()}
                 className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer"
               />
             )}
           </div>

           <div>
             <Button 
               variant="contained"
               endIcon={<SearchIcon />}
               sx={{
                 fontSize: "12px",
                 fontWeight: "bold",
                 fontFamily: "poppins",
                 padding: "4px 24px",
                 backgroundColor: "#ff6400",
                 transform: "all",
                 animationDuration: "1000",
                 textTransform: "none",
                 borderRadius: "8px",
                 '&:hover': {
                   backgroundColor: "#bb4a03",
                 }
               }}
               onClick={() => handleSearchClients()}
             >
               Buscar
             </Button>
           </div>

          <div className=" ">
            <button
              className="text-xs text-orange-600 bg-orange-500 bg-opacity-10 hover:bg-opacity-20 rounded-md p-3 "
              type="button"
              onClick={() => setOpenFilterModal(true)}
            >
              <FaFilter />
            </button>
          </div>

         </div>

        </div>
      </div>

      {/* Filtros */}       
      <div className="flex flex-row items-center justify-center bg-gray-100 mt-1 mb-1 gap-8">

        {/* Contenedor de Fecha inicio */}
        <div className="flex flex-row items-center justify-center gap-4">
          <span className="text-xs">Fecha inicio</span>
          <input 
            type="date" 
            className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </div>  

        {/* Contenedor de Fecha fin */}
        <div className="flex flex-row items-center justify-center gap-4">
          <span className="text-xs">Fecha fin</span>
          <input 
            type="date" 
            className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div> 

        {/* Rubro */}
        <div className="flex flex-row items-center justify-center gap-4">
          <span className="text-xs w-[20%]">Rubro</span>
          <select 
            type="date" 
            className="text-gray-700 hover:cursor-pointer w-[150px] text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
            value={rubroSelected}
            onChange={(e) => setRubroSelected(e.target.value)}
          >
            <option value="">Seleccionar</option>
            {rubros.map((rubro) => (
              <option value={rubro.id}>{rubro.name}</option>
            ))}
          </select>
        </div>  
        
        {/* Nicho */}
        <div className="flex flex-row items-center justify-center gap-4">
          <span className="text-xs w-[20%]">Nicho</span>
          <select 
            type="date" 
            className="text-gray-700 hover:cursor-pointer w-[150px] text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
            value={nichoSelected}
            onChange={(e) => setNichoSelected(e.target.value)}
          >
            <option value="">Seleccionar</option>
            {nichos.map((nicho) => (
              <option value={nicho.id}>{nicho.name}</option>
            ))}
          </select>
        </div> 

        {/* Activo agencia */}
        <div className="flex flex-row items-center justify-center gap-4">
          <span className="text-xs">Activos Agencia</span>
          <input
            type="checkbox"
            className="rounded-md border-gray-400 hover:cursor-pointer"
            checked={agencyWeb}
            onChange={(e) => setAgencyWeb(e.target.checked)}
          />
        </div>

      </div>

      {/* Body */}
      <div className="flex-grow overflow-y-auto">
        {loadingStatus ? (
            <div className="flex w-full h-full text-gray-700 items-center justify-center">
              <div className="flex w-full h-full text-xs gap-2 items-center justify-center">
                  <span>Cargando, por favor espera...</span>
                  <FaSpinner className="animate-spin text-gray-500" />
              </div>
            </div>
          ) : (
              clients.length === 0 ? (
                <div className="flex w-full h-full text-gray-700 items-center justify-center">
                  <div className="flex w-full h-full text-xs gap-2 items-center justify-center">
                      <span>No hay registros</span>
                      <FaInfoCircle className="text-gray-500" />
                  </div>
                </div>
            ) : (
              <table className="w-full table-fixed overflow-y-auto">
                <thead className="bg-white sticky top-0 z-50">
                  <tr className="w-full text-gray-700 text-center text-xs uppercase font-bold">

                    <td className="w-[20px] px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      <div 
                        className="flex items-center justify-center w-full"
                      >
                        <a className="p-2 text-white rounded-md flex items-center">
                          <BiWorld />
                        </a>
                      </div>
                    </td>

                    <td className="w-[150px] sticky left-0 z-10 px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      <div>
                        Cliente
                      </div>
                    </td>

                    {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (
                      <td className="w-[150px] px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        <div>
                          Tel. encargado
                        </div>
                      </td>
                     )}

                    {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (                    
                      <td className="w-[150px] px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        <div>
                          Tel. gerente
                        </div>
                      </td>
                    )}

                    <td className="w-[150px] px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      <div>
                        Rubro
                      </div>
                    </td>

                    <td className="w-[150px] px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      <div>
                        Nicho
                      </div>
                    </td>

                    {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (
                      <td className="w-[200px] px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        Venden
                      </td>
                    )}

                    {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (
                      <td className="w-[200px] px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        Ticket del producto
                      </td>
                     )}

                    {services
                      .filter((service) => serviceFilters.length === 0 || serviceFilters.includes(service.id))
                      .map((service) => (
                        <td
                          key={service.id}
                          className="px-3 py-3 w-[150px] text-center text-xs font-bold bg-[#FE6400] border-r border-r-gray-300 text-white"
                        >
                          <div className="truncate">{service.name}</div>
                        </td>
                      ))
                    }

                  </tr>
                </thead>

                <tbody>
                  {clients.map((client) => (
                    <tr
                      key={client.id}
                      className={`text-xs py-2 w-full hover:bg-gray-100 transition-all duration-300`}
                    >
                      <td scope="row" className="w-[20px] border border-gray-300">
                        <div 
                          className="flex items-center justify-center w-full"
                          onClick={() => {
                            setOpenClientMediaModal(true)
                            setSelectedClient(client)
                          }}
                        >
                          <a
                            className="p-2 text-blue-500 hover:bg-blue-600 hover:bg-opacity-25 hover:cursor-pointer rounded-md bg-blue-700 bg-opacity-10 flex items-center"
                          >
                            <BiWorld />
                          </a>
                        </div>
                      </td>

                      <td 
                        scope="row" 
                        className="max-w-[20px] sticky bg-white left-0 z-10 px-4 py-2 max-w-xs font-bold border-b border-b-gray-300 text-center hover:cursor-pointer hover:underline transition-all duration-100"
                      >
                        <a 
                          href={`/home/seguimiento/${client.id}`}
                          target="_blank" 
                          rel="noopener noreferrer"
                        >
                          {client.nombreComercial}
                        </a>
                      </td>

                      {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (                    
                        <td 
                          scope="row" 
                          className="px-4 py-2 border border-gray-300 text-center"
                        >
                          {client?.telefono}
                        </td>
                      )}

                      {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (                    
                        <td 
                          scope="row" 
                          className="px-4 py-2 border border-gray-300 text-center"
                        >
                          {client?.telefonoGerente}
                        </td>
                      )}

                      <td 
                        scope="row" 
                        className="px-4 py-2 border border-gray-300 text-center"
                      >
                        {client.nicho ? client.nicho?.rubro?.name : ""}
                      </td>

                      <td 
                        scope="row" 
                        className="px-4 py-2 border border-gray-300 text-center"
                      >
                        {client.nicho ? client.nicho?.name : ""}
                      </td>

                      {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (
                        <td 
                          scope="row" 
                          className="px-2 py-2 border border-gray-300 text-center"
                        >
                          <input 
                            type="text"
                            value={client.productos}
                            placeholder="Buzos, comida, maquinaria, etc"
                            className="text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent pr-2"
                            onChange={(e) => handleUpdateText("productos", e.target.value, client.id)}
                          />
                        </td>
                      )}
                      
                      {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (
                        <td 
                          scope="row" 
                          className="px-2 py-2 border border-gray-300 text-center"
                        >                        
                          <select 
                            type="text"
                            value={client.ticket}
                            className="w-[10rem] text-xs text-gray-700 bg-white border hover:cursor-pointer border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                            onChange={(e) => handleUpdateSelect("ticket", e.target.value, client.id)}
                          >
                            <option value="Seleccionar">Seleccionar</option>
                            <option value="Bajo: -S/.500">Bajo: -S/.500</option>
                            <option value="Normal: S/.800 - S/.3000">Normal: S/.800 - S/.3000</option>
                            <option value="Alto: +S/.5000">Alto: +S/.5000</option>
                          </select>
                        </td>
                      )}

                      {services
                        .filter((service) => serviceFilters.length === 0 || serviceFilters.includes(service.id))
                        .map((e) => {

                          const servicioRelacionado = client.services.find((serv) => serv.servicio.name === e.name);                          
                          const linkDemo = servicioRelacionado?.links?.find((link) => link.titulo === "Link demo");
                          const linkOficial = servicioRelacionado?.links?.find((link) => link.titulo === "Link web oficial");
                          //const linkBackup = servicioRelacionado?.links?.find((link) => link.titulo === "Link backup");
                          

                          return (
                            <td key={e.id} className="px-4 py-2 border border-gray-300">
                              {servicioRelacionado ? (
                                <div className="flex flex-col gap-2 items-center text-center justify-center">
                                  
                                  <div className="flex flex-row justify-center gap-2 items-center">
                                    <span className="p-2 bg-green-600 bg-opacity-10 text-green-600 rounded-md">
                                      Sí
                                    </span>
                                    
                                    <Tooltip content={`Links cliente`}>
                                      <a
                                        className="hover:cursor-pointer"
                                        onClick={() => {
                                          fetchLinkServiciosClientes(client.id, servicioRelacionado.servicio.id);
                                          setOpenLinksModal(true);
                                          setClientSelected(client.id)
                                          setServiceSelected(servicioRelacionado.servicio.id)
                                        }}
                                      >
                                        <FaLink className="text-gray-800" />
                                      </a>
                                    </Tooltip>
                                    
                                    {servicioRelacionado.servicio.categoria === "Web" && (
                                      <Tooltip content={`${linkDemo ? "Link demo" : "No hay link demo"}`}>
                                        <a 
                                          href={linkDemo?.url}
                                          target="_blank" 
                                          rel="noopener noreferrer"
                                        >
                                          <FaLink className={` ${!linkDemo ? "text-gray-200" : "text-gray-800"}`} />
                                        </a>
                                      </Tooltip>
                                    )}

                                    {servicioRelacionado.servicio.categoria === "Web" && (
                                      <Tooltip content={`${linkOficial ? "Link web oficial" : "No hay link oficial"}`}>
                                        <a 
                                          href={linkOficial?.url}
                                          target="_blank" 
                                          rel="noopener noreferrer"
                                        >
                                          < FaLink className={` ${!linkOficial ? "text-gray-200" : "text-gray-800"}`} />
                                        </a>
                                      </Tooltip>
                                     )}

                                  </div>

                                  <span>{servicioRelacionado?.cotizacion?.cotizador?.name || "Sin cotizador"}</span>

                                  <span className="truncate font-bold">          
                                    {(() => {
                                      const precioBase = servicioRelacionado.customPriceActive
                                        ? servicioRelacionado.customPrice * servicioRelacionado.numeroItems
                                        : servicioRelacionado.servicio &&
                                          servicioRelacionado.planServicio &&
                                          services
                                            .find((e) => e.id === servicioRelacionado.servicio.id)
                                            .preciosUnitarios.find(
                                              (ev2) => ev2.plan.id === servicioRelacionado.planServicio.id
                                            )?.precio * servicioRelacionado.numeroItems;

                                      // Calcular el descuento
                                      let montoDescuento = 0;
                                      if (servicioRelacionado.tipoDescuento === "Porcentaje") {
                                        montoDescuento = precioBase * (servicioRelacionado.montoDescuento / 100);
                                      } else if (servicioRelacionado.tipoDescuento === "Fijo") {
                                        montoDescuento = servicioRelacionado.montoDescuento;
                                      }

                                      // Restar el descuento del precio base
                                      const precioFinal = precioBase - montoDescuento;

                                      // Restar el descuento del precio base
                                      return `${precioFinal.toFixed(2)} ${servicioRelacionado.cotizacion.moneda}`;
                                    })()}
                                  </span>
                                  
                                </div>
                              ) : (
                                <div className="flex justify-center gap-2 items-center">
                                  <span className="text-gray-300">No</span>
                                  <FaLink className="text-gray-300"/>
                                </div>
                              )}
                            </td>
                          );
                        })
                      }

                    </tr>
                  ))}

                </tbody>
              </table>
            )
          )
        }
      </div>

      {/* Paginador */}
      <div className="w-full flex flex-col gap-4 py-4 justify-center items-center ">
        <span className="text-sm text-gray-700 dark:text-gray-500 ">
          Mostrando
          <span className="font-semibold text-gray-900 dark:text-gray-300 ">
            {" "}
            {clients.length}
          </span>{" "}
          de
          <span className="font-semibold text-gray-900 dark:text-gray-300 ">
            {" "}
            {totalDocs}
          </span>{" "}
          clientes
        </span>
        <Pagination
          count={totalPages}
          page={page}
          variant="outlined" 
          shape="rounded"
          onChange={handlePageChange}
        />
      </div>

    </div>
  );
};

export default RedesClientes;
